// ignore-string-externalization

import React from 'react';
import { Videos } from '../../features/Videos';
import { loadVideos } from '../../utils/redux/store/videos';

const VideosPage = () => {
  return <Videos />;
};

VideosPage.getInitialProps = async ({
  store,
  smartlingLanguage,
  preview,
}: $TSFixMe) => {
  return store
    .dispatch(loadVideos({ smartlingLanguage, preview } as $TSFixMe))
    .then(() => {
      return { loaded: true, preview };
    });
};

export default VideosPage;
